import './WidgetCellSelector.css';

import React, { useEffect } from 'react';

const WidgetCellSelector = ({ dashboard, widget = null, onSelectedCell }) => {
    const [currentDashboard, setCurrentDashboard] = React.useState(dashboard);
    const [selectedCell, setSelectedCell] = React.useState(null);
    const [currentWidget, setCurrentWidget] = React.useState(widget);
    const [currentCoordinates, setCurrentCoordinates] = React.useState(null);
    const [currentSize, setCurrentSize] = React.useState(null);

    useEffect(() => {
        if (currentDashboard !== dashboard)
            setCurrentDashboard(dashboard);
    }, [dashboard]);

    useEffect(() => {
        const widgetCoordinates = {
            row: widget?.widgetConfig.row,
            column: widget?.widgetConfig.column
        };
        const widgetSize = {
            width: widget?.widgetConfig.width,
            height: widget?.widgetConfig.height
        };
        if (currentCoordinates?.row !== widgetCoordinates?.row || currentCoordinates?.column !== widgetCoordinates?.column)
            setCurrentCoordinates(widgetCoordinates);
        if (currentSize?.width !== widgetSize?.width || currentSize?.height !== widgetSize?.height)
            setCurrentSize(widgetSize);
        setCurrentWidget(widget);
        const cell = { row: widgetCoordinates?.row, col: widgetCoordinates?.column, width: widgetSize?.width, height: widgetSize?.height };
        setSelectedCell(cell);
        onSelectedCell && onSelectedCell(cell);
    }, [widget]);

    useEffect(() => {
        // to force re-render
    }, [currentDashboard, currentWidget]);

    const handleCellClick = (row, col) => {
        const cell = { row, col, width: currentSize.width, height: currentSize.height };
        // console.log('handleCellClick currentWidget', currentWidget);
        // console.log('handleCellClick', cell);
        setSelectedCell(cell);
        onSelectedCell && onSelectedCell(cell);
    };

    const getOccupiedCells = () => {
        const occupiedCells = new Set();
        const currentWidgetCells = new Set();

        currentDashboard.widgets.forEach(widget => {
            const { row, column, width, height } = widget.widgetConfig;
            // console.log('WidgetCellSelector', widget.widgetConfig);
            for (let r = row; r < row + height; r++) {
                for (let c = column; c < column + width; c++) {
                    const cellKey = `${r}-${c}`;
                    if (currentWidget && widget.widgetId === currentWidget.widgetId) {
                        currentWidgetCells.add(cellKey);
                    } else {
                        occupiedCells.add(cellKey);
                    }
                }
            }
        });
        // console.log('WidgetCellSelector', occupiedCells, currentWidgetCells);
        return { occupiedCells, currentWidgetCells };
    };

    const renderGrid = () => {
        // console.log('WidgetCellSelector renderGrid');
        const { rows, columns } = currentDashboard.dashboardConfig;
        const { occupiedCells, currentWidgetCells } = getOccupiedCells();
        const grid = [];
        for (let row = 1; row <= rows; row++) {
            const rowCells = [];
            for (let col = 1; col <= columns; col++) {
                const cellKey = `${row}-${col}`;
                const isOccupied = occupiedCells.has(cellKey);
                const isCurrentWidgetOccupied = currentWidgetCells.has(cellKey);
                const isSelected = selectedCell &&
                    row >= selectedCell.row && row < selectedCell.row + selectedCell.height &&
                    col >= selectedCell.col && col < selectedCell.col + selectedCell.width;
                rowCells.push(
                    <div
                        key={cellKey}
                        className={`cell ${isSelected ? 'selected' : ''} ${isOccupied ? 'occupied' : ''} ${isCurrentWidgetOccupied ? 'occupied_current_widget' : ''}`}
                        onClick={!isOccupied ? () => handleCellClick(row, col) : null}
                    >
                        {`${row},${col}`}
                    </div>
                );
            }
            grid.push(<div key={row} className="row">{rowCells}</div>);
        }
        return grid;
    };

    return (
        <div className="grid-container">
            {renderGrid()}
        </div>
    );
};

export default WidgetCellSelector;